module.exports = __webpack_public_path__ + "img/creative_idea.4abffeb1.svg";